module.exports = __webpack_public_path__ + "media/images/sponsor/concept-award-13769f381cd7161c6a9db9a93210a6f3.png";